import { formatDecimalPlaces } from "../../../../../helpers/format-decimal-places";
import { useGetMyProfile } from "../../../../../hooks/profile/use-get-my-profile";

export const InfoCoins = () => {
  const { user } = useGetMyProfile();

  return (
    <div
      style={{
        background: "linear-gradient(90deg, #fca91d, #ff7b00)",
        borderRadius: "10px",
        padding: "20px",
        textAlign: "center",
        color: "#fff",
        marginBottom: "20px",
        justifyContent: "center",
      }}
    >
      <div style={{ fontSize: "28px", fontWeight: "bold" }}>
        {formatDecimalPlaces(user?.agency?.coinsForSale ?? 0)}
      </div>

      <div
        style={{
          fontSize: "14px",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          gap: "5px",
        }}
      >
        Coins Trading
        <img src={"/coin.png"} style={{ width: "18px" }} />
      </div>
    </div>
  );
};
